'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.verifyCode = exports.retryCall = exports.retryText = exports.submitPhoneNumberAndCall = exports.submitPhoneNumberAndText = exports.submitPhoneNumber = exports.loadData = exports.PHONE_VERIFICATION_FORM_NAME = exports.CODE_VERIFICATION_FORM_NAME = exports.LOAD_PHONE_VERIFICATION_PAGE = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.findCountry = findCountry;
exports.doGetScheduleId = doGetScheduleId;
exports.doHandlePostVerification = doHandlePostVerification;
exports.doLoadData = doLoadData;
exports.doVerifyCodeOperation = doVerifyCodeOperation;
exports.doSubmitNumberOperation = doSubmitNumberOperation;
exports.doPhoneVerificationOperation = doPhoneVerificationOperation;
exports.userNeedsPhoneVerification = userNeedsPhoneVerification;
exports.watchPhoneVerificationSagas = watchPhoneVerificationSagas;

var _reactRouterRedux = require('react-router-redux');

var _reduxFormSaga = require('redux-form-saga');

var _sagaTools = require('@classpass/saga-tools');

var _reduxForm = require('redux-form');

var _effects = require('redux-saga/effects');

var _bound = require('redux/saga/entities/bound');

var _venueDetail = require('redux/modules/features/venue-detail');

var _multitrack = require('helpers/multitrack');

var _forms = require('helpers/forms');

var _deep = require('helpers/deep');

var _Base = require('derivers/Base64');

var _Base2 = _interopRequireDefault(_Base);

var _phoneVerification = require('redux/saga/selectors/phoneVerification');

var _request = require('redux/saga/selectors/request');

var _user = require('redux/saga/selectors/user');

var _phoneVerification2 = require('redux/modules/features/phone-verification');

var _PhoneVerification = require('./PhoneVerification.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(findCountry),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doGetScheduleId),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doHandlePostVerification),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doLoadData),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doVerifyCodeOperation),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(doSubmitNumberOperation),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(doPhoneVerificationOperation),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(userNeedsPhoneVerification),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(watchPhoneVerificationSagas);

var ITEM_CODE = 'Code';
var ITEM_PHONE = 'Phone';

var LOAD_PHONE_VERIFICATION_PAGE = exports.LOAD_PHONE_VERIFICATION_PAGE = 'classpass/phoneVerification:LOAD_DATA';

var CODE_VERIFICATION_FORM_NAME = exports.CODE_VERIFICATION_FORM_NAME = 'verify-phone-code';
var PHONE_VERIFICATION_FORM_NAME = exports.PHONE_VERIFICATION_FORM_NAME = 'verify-phone-number';

var loadData = exports.loadData = function loadData(countryCode, params) {
  return { type: LOAD_PHONE_VERIFICATION_PAGE, countryCode: countryCode, params: params };
};
var submitPhoneNumber = exports.submitPhoneNumber = (0, _reduxFormSaga.createFormAction)('submitPhoneNumber');
var submitPhoneNumberAndText = exports.submitPhoneNumberAndText = (0, _forms.augmentSubmitActionWithAdditionalData)(submitPhoneNumber, { deliveryMethod: _PhoneVerification.DELIVERY_METHOD_SMS });
var submitPhoneNumberAndCall = exports.submitPhoneNumberAndCall = (0, _forms.augmentSubmitActionWithAdditionalData)(submitPhoneNumber, { deliveryMethod: _PhoneVerification.DELIVERY_METHOD_VOICE });
var retryText = exports.retryText = (0, _forms.augmentSubmitActionWithAdditionalData)(submitPhoneNumber, { deliveryMethod: _PhoneVerification.DELIVERY_METHOD_SMS, retry: true });
var retryCall = exports.retryCall = (0, _forms.augmentSubmitActionWithAdditionalData)(submitPhoneNumber, { deliveryMethod: _PhoneVerification.DELIVERY_METHOD_VOICE, retry: true });
var verifyCode = exports.verifyCode = (0, _reduxFormSaga.createFormAction)('verifyCode');

function findCountry(key, value) {
  var countries;
  return _regenerator2.default.wrap(function findCountry$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_bound.getCountries.data);

        case 2:
          countries = _context.sent;
          return _context.abrupt('return', countries.find(function (country) {
            return String(country[key]) === value;
          }));

        case 4:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doGetScheduleId(params) {
  var _deepExtract, _deepExtract2, encodedScheduleId, scheduleId;

  return _regenerator2.default.wrap(function doGetScheduleId$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _deepExtract = (0, _deep.deepExtract)('splat', params, []), _deepExtract2 = (0, _slicedToArray3.default)(_deepExtract, 2), encodedScheduleId = _deepExtract2[1];
          scheduleId = _Base2.default.decodeNumber(encodedScheduleId);
          _context2.next = 4;
          return (0, _effects.put)((0, _venueDetail.setScheduleId)(scheduleId || 0));

        case 4:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doHandlePostVerification() {
  var path;
  return _regenerator2.default.wrap(function doHandlePostVerification$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(_bound.isUserVerified.resetAction());

        case 2:
          _context3.next = 4;
          return (0, _effects.select)(_request.pathSelector);

        case 4:
          path = _context3.sent;
          _context3.next = 7;
          return (0, _effects.put)((0, _reactRouterRedux.push)(path.replace(/^\/[^/]+(\/enter-code)?/, '/purchase')));

        case 7:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function doLoadData(client, _ref) {
  var countryCode = _ref.countryCode,
      params = _ref.params;
  var countries, countryId;
  return _regenerator2.default.wrap(function doLoadData$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(doGetScheduleId, params);

        case 3:
          _context4.next = 5;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.getCountries, [client]);

        case 5:
          countries = _context4.sent;
          countryId = countries.find(function (country) {
            return country.code === countryCode;
          }).id;
          _context4.next = 9;
          return (0, _effects.put)((0, _reduxForm.change)(PHONE_VERIFICATION_FORM_NAME, 'countryId', String(countryId)));

        case 9:
          _context4.next = 17;
          break;

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4['catch'](0);
          _context4.next = 15;
          return (0, _effects.put)((0, _phoneVerification2.skipPhoneVerification)());

        case 15:
          _context4.next = 17;
          return (0, _effects.call)(doHandlePostVerification);

        case 17:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[0, 11]]);
}

function doVerifyCodeOperation(client, _ref2) {
  var code = _ref2.code,
      countryCallingCode = _ref2.countryCallingCode,
      phoneNumber = _ref2.phoneNumber;
  return _regenerator2.default.wrap(function doVerifyCodeOperation$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.call)(client.phoneVerification.checkValidationCode, {
            code: code,
            country_code: countryCallingCode,
            phone_number: phoneNumber
          });

        case 2:
          _context5.next = 4;
          return (0, _effects.call)(doHandlePostVerification);

        case 4:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function doSubmitNumberOperation(client, _ref3) {
  var countryId = _ref3.countryId,
      deliveryMethod = _ref3.deliveryMethod,
      phoneNumber = _ref3.phoneNumber,
      retry = _ref3.retry;
  var country, response, path;
  return _regenerator2.default.wrap(function doSubmitNumberOperation$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.call)(findCountry, 'id', countryId);

        case 2:
          country = _context6.sent;
          _context6.next = 5;
          return (0, _effects.call)(client.phoneVerification.sendValidationCode, {
            country_code: country.calling_code,
            delivery_method: deliveryMethod.toLowerCase(),
            phone_number: phoneNumber
          });

        case 5:
          response = _context6.sent;

          if (!(response.status === _PhoneVerification.ALREADY_VERIFIED)) {
            _context6.next = 10;
            break;
          }

          _context6.next = 9;
          return (0, _effects.call)(doHandlePostVerification);

        case 9:
          return _context6.abrupt('return');

        case 10:
          if (retry) {
            _context6.next = 18;
            break;
          }

          _context6.next = 13;
          return (0, _effects.put)((0, _reduxForm.initialize)(CODE_VERIFICATION_FORM_NAME, {
            countryCallingCode: country.calling_code,
            countryShortCode: country.short_code,
            phoneNumber: phoneNumber
          }));

        case 13:
          _context6.next = 15;
          return (0, _effects.select)(_request.pathSelector);

        case 15:
          path = _context6.sent;
          _context6.next = 18;
          return (0, _effects.put)((0, _reactRouterRedux.push)(path.replace(/^(\/[^/]+)/, '$1/enter-code')));

        case 18:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function doPhoneVerificationOperation(client, form, item, operation, _ref4) {
  var payload = _ref4.payload;
  var error, eventAction, scheduleId, action;
  return _regenerator2.default.wrap(function doPhoneVerificationOperation$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          error = void 0;
          _context7.prev = 1;
          _context7.next = 4;
          return (0, _effects.call)(operation, client, payload);

        case 4:
          _context7.next = 6;
          return (0, _effects.put)(form.success());

        case 6:
          _context7.next = 28;
          break;

        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7['catch'](1);

          error = { message: _PhoneVerification.ERROR_CODE_MAPPING[_context7.t0.httpStatus] || _context7.t0.message };
          eventAction = void 0;

          if (!(_context7.t0.httpStatus === 403)) {
            _context7.next = 20;
            break;
          }

          eventAction = _PhoneVerification.CODE_ERROR;
          // As a 403 can be returned for multiple reasons, when the
          // err.message is 'Duplicate Number' we ensure that message
          // is displayed to the user rather than the ERROR_CODE_MAPPING value
          if (_context7.t0.message === _PhoneVerification.DUPLICATE_NUMBER) {
            error.message = _context7.t0.message;
            eventAction = _PhoneVerification.DUPLICATE_NUMBER_ERROR;
          }
          _context7.next = 17;
          return (0, _effects.select)(_venueDetail.selectScheduleId);

        case 17:
          scheduleId = _context7.sent;
          _context7.next = 20;
          return (0, _effects.spawn)(_multitrack.ga, 'Membership Purchase', eventAction, scheduleId);

        case 20:
          if (_PhoneVerification.ERROR_CODE_MAPPING[_context7.t0.httpStatus]) {
            _context7.next = 26;
            break;
          }

          _context7.next = 23;
          return (0, _effects.put)(form.success());

        case 23:
          _context7.next = 25;
          return (0, _effects.call)(doHandlePostVerification);

        case 25:
          return _context7.abrupt('return');

        case 26:
          _context7.next = 28;
          return (0, _effects.put)(form.failure(new _reduxForm.SubmissionError({ _error: error })));

        case 28:
          _context7.prev = 28;
          action = void 0;

          if (item === ITEM_PHONE) {
            action = '' + (payload.retry ? 'retry_' : '') + (payload.deliveryMethod === _PhoneVerification.DELIVERY_METHOD_SMS ? 'sms' : 'call');
          }

          _context7.next = 33;
          return (0, _effects.spawn)(_multitrack.ec, 'Verify Phone - Submit ' + item, (0, _extends3.default)({}, error && { error: error.message }, {
            action: action
          }));

        case 33:
          return _context7.finish(28);

        case 34:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[1, 8, 28, 34]]);
}

function userNeedsPhoneVerification(client) {
  var shouldVerify, isVerified;
  return _regenerator2.default.wrap(function userNeedsPhoneVerification$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(_phoneVerification.shouldSkipPhoneVerification);

        case 2:
          shouldVerify = !_context8.sent;

          if (shouldVerify) {
            _context8.next = 5;
            break;
          }

          return _context8.abrupt('return', false);

        case 5:
          _context8.next = 7;
          return (0, _effects.select)(_user.isLoggedIn);

        case 7:
          _context8.t0 = _context8.sent;

          if (!_context8.t0) {
            _context8.next = 12;
            break;
          }

          _context8.next = 11;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.isUserVerified, [client]);

        case 11:
          _context8.t0 = _context8.sent;

        case 12:
          isVerified = _context8.t0;
          return _context8.abrupt('return', !isVerified);

        case 14:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}

function watchPhoneVerificationSagas(client) {
  return _regenerator2.default.wrap(function watchPhoneVerificationSagas$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, LOAD_PHONE_VERIFICATION_PAGE, doLoadData, client);

        case 2:
          _context9.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, submitPhoneNumber.REQUEST, doPhoneVerificationOperation, client, submitPhoneNumber, ITEM_PHONE, doSubmitNumberOperation);

        case 4:
          _context9.next = 6;
          return (0, _effects.fork)(_effects.takeEvery, verifyCode.REQUEST, doPhoneVerificationOperation, client, verifyCode, ITEM_CODE, doVerifyCodeOperation);

        case 6:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this);
}